import type { Slide } from '../../content/decks/types'
import {
  TitleSlide,
  StatSlide,
  SplitSlide,
  BulletsSlide,
  QuoteSlide,
  CTASlide,
  CascadeSlide,
  StepsSlide,
  CodeExampleSlide,
  ChecklistSlide,
  SectionDividerSlide,
  ExerciseSlide,
  ComparisonSlide,
  ReferenceSlide,
} from './layouts'

export function SlideRenderer({ slide }: { slide: Slide }) {
  switch (slide.layout) {
    case 'title':
      return <TitleSlide slide={slide} />
    case 'stat':
      return <StatSlide slide={slide} />
    case 'split':
      return <SplitSlide slide={slide} />
    case 'bullets':
      return <BulletsSlide slide={slide} />
    case 'quote':
      return <QuoteSlide slide={slide} />
    case 'cta':
      return <CTASlide slide={slide} />
    case 'cascade':
      return <CascadeSlide slide={slide} />
    case 'steps':
      return <StepsSlide slide={slide} />
    case 'codeExample':
      return <CodeExampleSlide slide={slide} />
    case 'checklist':
      return <ChecklistSlide slide={slide} />
    case 'sectionDivider':
      return <SectionDividerSlide slide={slide} />
    case 'exercise':
      return <ExerciseSlide slide={slide} />
    case 'comparison':
      return <ComparisonSlide slide={slide} />
    case 'reference':
      return <ReferenceSlide slide={slide} />
    default:
      return null
  }
}
